<script setup lang="ts">
import { useVModel } from '@vueuse/core'

import type { Address } from '~/layers/forms/models'
import { Form } from '~/layers/forms/models'

interface Props {
  modelValue: Address
  validationScope?: string
  argentoInsuranceCompanyId?: number | null
  argentoInsuranceProductId?: number | null
  argentoInsurancebrokerProductId?: number | null
}

const props = withDefaults(defineProps<Props>(), {
  validationScope: Form.address,
  argentoInsuranceCompanyId: null,
  argentoInsuranceProductId: null,
  argentoInsurancebrokerProductId: null,
})

const emits = defineEmits(['update:modelValue'])
const model = useVModel(props, 'modelValue', emits)
</script>

<template>
  <FormsGlobalContainer
    v-slot="{ sectionClasses }"
    :identifier="Form.address"
  >
    <FormsGlobalTitle
      text="Dirección del contratante"
      icon-class="icon-[ph--map-pin-bold]"
    />
    <FormsGlobalAddressBaseForm
      v-model="model"
      :argento-insurance-company-id
      :argento-insurance-product-id
      :argento-insurancebroker-product-id
      :validation-scope
      :line-section-classes="sectionClasses({ cols: 2 })"
    />
  </FormsGlobalContainer>
</template>
